import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-hotel-manage',
  templateUrl: './hotel-manage.component.html',
  styleUrls: ['./hotel-manage.component.scss']
})
export class HotelManageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
